import {UseFieldArrayMove} from "react-hook-form";
import {OfferingFormCheckoutFormQuestionFields} from "../types";

export function reorderList(
  newFields: OfferingFormCheckoutFormQuestionFields,
  fields: OfferingFormCheckoutFormQuestionFields,
  move: UseFieldArrayMove
) {
  // Find the first index where the order differs
  const firstDiffIndex = fields.findIndex(
    (field, index) => field.id !== newFields[index].id
  );
  if (firstDiffIndex !== -1) {
    // Find the new index of the item that was moved
    const newIndex = newFields.findIndex(
      (field) => field.id === fields[firstDiffIndex].id
    );
    // Swap the items
    move(firstDiffIndex, newIndex);
  }
}
